import { useEffect } from 'react'
import posthog from 'posthog-js'

import { useFeatureFlags } from './useFeatureFlags'

const WEB_RUNTIME_FLAGS = ['hasFreePlanWebRuntimeBanner']

// Used to get web-runtime-specific flags from outside the React context
// (e.g. `getAdaloFooterHeight` reads `window.flags` synchronously from inside
// `Renderer`/`Share`).
const setWebRuntimeFlagsToWindow = flags => {
  window.flags = {}
  WEB_RUNTIME_FLAGS.forEach(key => {
    if (key in flags) {
      window.flags[key] = flags[key]
    }
  })
}

const FeatureFlagIdentitySync = ({ app }) => {
  const flags = useFeatureFlags()

  const { flagUser } = app || {}

  // Identify into PostHog whenever the app (and therefore flagUser) changes.
  // `flagUser` is shaped as PostHog's native evaluation context — see
  // backend/lib/featureFlags.js → getFlagUserContext.
  useEffect(() => {
    if (!flagUser) return

    const {
      distinctId,
      personProperties = {},
      groups = {},
      groupProperties = {},
    } = flagUser

    if (distinctId) {
      posthog.identify(distinctId, personProperties)
    } else if (Object.keys(personProperties).length > 0) {
      posthog.setPersonProperties(personProperties)
    }

    Object.entries(groups).forEach(([groupType, groupKey]) => {
      posthog.group(groupType, groupKey, groupProperties[groupType])
    })
  }, [flagUser])

  // Keep `window.flags` in sync with the latest evaluated flag values so
  // synchronous consumers (e.g. `getAdaloFooterHeight`) see fresh data.
  useEffect(() => {
    setWebRuntimeFlagsToWindow(flags || {})
  }, [flags])

  return null
}

export default FeatureFlagIdentitySync
